import { observable } from "mobx";
import { IService, IComponent } from "../_types/interfaces";
import i18n from 'i18next';
import { importService } from "../_services";

const translate = (name: string) => i18n.t('importService.importSecureFile.' + name);

export const importStore = observable({
    loading: false,
    message: "",
    loadStatusInterval: null as any,
    loadStatus: false,
    showMessage(message: string) {
        this.message = message;
    },
    async importSecureFile(names: Array<File>) {
        this.loading = true;
        try {
            const formData = new FormData();
            names.forEach(file => {
                formData.append("formFile", file);
            });
            await importService.importSecureFile(formData);
            this.showMessage(translate('import_ok'));
            this.loadStatusInterval = setInterval(() => this.checkLicenseLoadStatus(), 100) as any;
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('import_error'));
        }
        this.loading = false;
    },

    async checkLicenseLoadStatus() {
        this.loadStatus = await importService.checkLicenseLoadStatus();
        if(this.loadStatus)
            return;
        clearInterval(this.loadStatusInterval)
    },
});